import {
  equipmentService,
  examService,
  laboratoryService,
  macroExamService,
  workstationService
} from 'shared/services';
import { Option } from 'shared/types/general';
import { ProductWarehouseLinkMode } from '../types';
import { operationalUnitService } from 'features/settings/topology/api/operational-unit.service';
import { productWarehouseService } from '../../api/product-warehouse.service';
import { sectorService } from 'features/settings/topology/api/sector.service';

const mapBaseInfoOptions = (items: { id: number; description: string }[]): Option[] =>
  items.map((item) => ({
    id: item.id,
    code: item.description
  }));

export const productWarehouseCostApi = {
  getLinkOptions: async (mode: ProductWarehouseLinkMode): Promise<Option[]> => {
    if (!mode) return [];
    if (mode === 'laboratories')
      return mapBaseInfoOptions(await laboratoryService.getAllBaseInformation());
    if (mode === 'operational_units') {
      return mapBaseInfoOptions(await operationalUnitService.getAllBaseInformation());
    }
    if (mode === 'sectors') return mapBaseInfoOptions(await sectorService.getAllBaseInformation());
    if (mode === 'workstations')
      return mapBaseInfoOptions(await workstationService.getAllBaseInformation());
    if (mode === 'equipments')
      return mapBaseInfoOptions(await equipmentService.getAllBaseInformation());
    if (mode === 'exams') return mapBaseInfoOptions(await examService.getAllBaseInformation());
    if (mode === 'macroexams') return await macroExamService.getAllBaseInformation();
    return [];
  },
  addCostLink: (productWarehouseId: number, mode: ProductWarehouseLinkMode, objectId: number) => {
    if (mode === 'exams') {
      return examService.assignProductWarehouse(objectId, productWarehouseId);
    }
    return productWarehouseService.addCostLink(productWarehouseId, {
      model: mode,
      object_id: objectId
    });
  }
};
